Wee.fn.make('promotions', {
	init: function() {
		var $priv = this.$private;

		$priv.initEvents();
	},
	unload: function() {
		$.events.off(null, '.promotions');
	}
}, {
	initEvents: function() {
		var $productResults = $('ref:productsResults');

		$.events.on({
			'ref:paginateNum': {
				click: function(e, el) {
					var query = {
							perPage: $(el).attr('data-val')
						};

					$.history.go({
						path: $.routes.uri().path + '?' + $.serialize(query),
						scrollTop: $productResults
					});
				}
			},
			'ref:typeFilter': {
				change: function(e, el) {
					var filters = {};

					if (el.value === 'featured') {
						filters.order = 'featured';
					} else if (el.value === 'asc') {
						filters.order = 'asc';
					} else if (el.value === 'desc') {
						filters.order = 'desc';
					} else if (el.value === 'justAdded') {
						filters.order = 'justAdded';
					}

					$.history.go({
						path: $.routes.uri().path + '?' + $.serialize(filters),
						scrollTop: $productResults
					});
				}
			}
		});
	}
});
